import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';

type TitleProps = {
  children: React.ReactNode;
};

const useStyles = makeStyles((theme: any) => ({
  title: {
    fontWeight: 500,
    color: theme.palette.tab.offselected,
  },
}));

const Title = ({ children }: TitleProps) => {
  const classes = useStyles();

  return (
    <Typography variant="h6" className={classes.title}>
      {children}
    </Typography>
  );
};

export default Title;
